import React, { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import SEO from '../shared/SEO';
import Navigation from '../../components/Navigation';
import HeroSection from './sections/HeroSection';
import ConceptSection from './sections/ConceptSection';
import SeasonsSection from './sections/SeasonsSection';
import CraftsmanshipSection from './sections/CraftsmanshipSection';
import ExperienceSection from './sections/ExperienceSection';
import ArticlesSection from './sections/ArticlesSection';
import FAQSection from './sections/FAQSection';
import Footer from '../../components/Footer';
import AdUnit from '../../components/AdUnit';
import { useTheme } from '../../hooks/useTheme';
import { AD_POSITIONS } from '../../utils/adConfig';
import { generateHomePageSchema } from '../../lib/seo';
import { FAQ_DATA } from './sections/FAQSection';

function HomePage() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { theme } = useTheme();

  useEffect(() => {
    const section = searchParams.get('section');
    if (section) {
      setTimeout(() => {
        const element = document.getElementById(section);
        if (element) {
          const offset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;
          window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
        }
      }, 100);
    } else if (location.pathname === '/' && !location.hash) {
      window.scrollTo(0, 0);
    }
  }, [location, searchParams]);

  // ✅ 修正：使用 generateHomePageSchema，傳入 FAQ_DATA
  // 內部用 strip() 正確移除 @context，不再有 undefined key 問題
  const combinedSchema = generateHomePageSchema(
    FAQ_DATA.map(item => ({ question: item.question, answer: item.answer }))
  );

  return (
    <>
      <SEO
        title="Omakase 完全指南 - 從入門到精通的日式料理體驗"
        description="探索 Omakase 的精髓！從基礎知識到進階技巧，了解日本料理文化、用餐禮儀、季節食材與頂級食材的秘密，帶您體驗最道地的板前料理。"
        keywords="Omakase,お任せ,日本料理,壽司,懷石料理,板前料理,日式美食,用餐禮儀,季節食材,台灣日本料理"
        type="website"
        url="/"
        image="https://images.unsplash.com/photo-1579952363873-27d3bfad9c0d?w=1200&h=630&fit=crop"
        schema={combinedSchema}
      />

      <div className={`min-h-screen ${theme === 'dark' ? 'dark' : ''}`}>
        <Navigation />

        <main>
          <HeroSection />
          <ConceptSection />
          <AdUnit {...AD_POSITIONS.HOME.banner1} />
          <SeasonsSection />
          <CraftsmanshipSection />
          <AdUnit {...AD_POSITIONS.HOME.banner2} />
          <ExperienceSection />
          <ArticlesSection />
          <FAQSection />
        </main>

        <Footer />
      </div>
    </>
  );
}

export default HomePage;